export var getBackgroundColorWidthConfig = function getBackgroundColorWidthConfig(bgColor, rowType) {
  return bgColor ? bgColor : rowType === 'bgBlock' ? 'rgba(0,0,0,0.8)' : '#fff';
};
export var getBackgroundWithRowType = function getBackgroundWithRowType(rowType, bgColor, config) {
  return rowType !== 'bgBlock' ? {
    background: bgColor
  } : {
    backgroundImage: "linear-gradient(" + bgColor + "," + bgColor + "), url(" + config.imgSrc + ")"
  };
};